<template>
    <td-dialog
        :title="$t(title)"
        @cancel="trusteeshipAddDialogClose"
        :before-close="trusteeshipAddDialogClose"
        :visible.sync="dialogTrusteeshipAddVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="1200px"
        top="18vh"
    >
        <el-form :inline="true" :model="formQuery" ref="formQuery">
            <el-form-item :label="$t('pgCommon.TABLE_NAME')" prop="sTableName">
                <td-input v-model="formQuery.sTableName" @keyup.enter.native="btnQuery"></td-input>
            </el-form-item>
            <el-form-item class="paddingLeft10">
                <td-button type="primary" :loading="loading" @click="btnQuery">{{ $t('pgCommon.QUERY') }}</td-button>
            </el-form-item>
        </el-form>
        <td-table
            :columns="columns"
            :dataSource="tableData"
            :pageSize="pageSize"
            :currentPage="currentPage"
            :total="total"
            rowKey="sTableName"
            height="400px"
            :hasPageMemory="true"
            @handleSizeChange="handleSizeChange"
            @currentChange="currentChange"
            ref="tableInfo"
        ></td-table>
        <span slot="footer">
            <el-row class="paddingTop10">
                <el-col>
                    <td-button type="primary" :loading="addLoading" @click="submitForm('formTrusteeship')">{{ $t('pgCommon.SAVE') }}</td-button>
                    <td-button @click="cancel">{{ $t('pgCommon.CANCEL') }}</td-button>
                </el-col>
            </el-row>
        </span>
    </td-dialog>
</template>
<script>
import dlgTrusteeshipApi from './../assets/api.js';
import HashMap from 'hashmap';
export default {
    props: ['title', 'dialogTrusteeshipAddVisible', 'treeNode', 'isAddData'],
    created() {
        this.checkedMap = new HashMap();
        this.queryDataList();
    },
    // 定义变量
    data() {
        return {
            tableData: [],
            selectModule: [], // 下拉框数据
            checkBoxModule: [], // checkBox数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            addLoading: false, // 按钮是否为加载状态
            // 表单信息
            formQuery: {
                sTableName: '',
                sTableNotes: ''
            },
            // checkedMap: {},
            // 是否字典表
            optionsDictionary: [
                {
                    value: 0,
                    label: this.$t('pgCommon.NOT')
                },
                {
                    value: 1,
                    label: this.$t('pgCommon.YES')
                }
            ],
            // 对表单进行数据验证
            rules: {
                sTableName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    // eslint-disable-next-line standard/object-curly-even-spacing
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                sTableNotes: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    // eslint-disable-next-line standard/object-curly-even-spacing
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL'), trigger: 'blur' }
                ]
            },
            columns: [
                {
                    prop: 'sTableName',
                    label: 'pgCommon.TABLE_NAME'
                },
                {
                    prop: 'sTableNotes',
                    label: 'pgCommon.TABLE_NOTES',
                    tableWidth: '200'
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.TABLE_DICTIONARY'),
                    tableWidth: '80',
                    align: 'center',
                    render: (createElement, params) => {
                        let checkStatus = false;
                        if (this.checkedMap.has(params.row.sTableName)) {
                            checkStatus = true;
                        }
                        return createElement('div', [
                            createElement('td-checkbox', {
                                props: {
                                    checked: checkStatus
                                },
                                on: {
                                    change: val => {
                                        this.checkBoxChange(params.row, val);
                                    }
                                }
                            })
                        ]);
                    }
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.KEY_FIELD'),
                    align: 'center',
                    render: (createElement, params) => {
                        //下拉框选项
                        let options = params.row.sColumnList;
                        if (options == null || options.length < 1) {
                            return;
                        }
                        //下拉框内容包裹在一个div里面
                        return createElement(
                            'div',
                            {
                                style: {
                                    height: '56px'
                                }
                            },
                            [
                                createElement('td-select', {
                                    style: {
                                        marginTop: '10px',
                                        width: '120px;'
                                    },
                                    //td-select实现下拉框
                                    on: {
                                        input: value => {
                                            //随着下拉框的不同，文字框里的内容在边
                                            this.selectModule[params.row.sTableName + '_key'] = value;
                                        }
                                    },
                                    props: {
                                        //props:{}为自定义属性
                                        value: this.selectModule[params.row.sTableName + '_key'],
                                        options: options
                                    }
                                })
                            ]
                        );
                    }
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.VALUE_FIELD'),
                    align: 'center',
                    render: (createElement, params) => {
                        //下拉框选项
                        let options = params.row.sColumnList;
                        if (options == null || options.length < 1) {
                            return;
                        }
                        //下拉框内容包裹在一个div里面
                        return createElement(
                            'div',
                            {
                                style: {
                                    height: '56px'
                                }
                            },
                            [
                                createElement('td-select', {
                                    style: {
                                        marginTop: '10px',
                                        width: '120px;'
                                    },
                                    //td-select实现下拉框
                                    on: {
                                        input: value => {
                                            //随着下拉框的不同，文字框里的内容在边
                                            this.selectModule[params.row.sTableName + '_value'] = value;
                                        }
                                    },
                                    props: {
                                        value: this.selectModule[params.row.sTableName + '_value'],
                                        options: options
                                    }
                                })
                            ]
                        );
                    }
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.DESC_FIELD'),
                    align: 'center',
                    render: (createElement, params) => {
                        //下拉框选项
                        let options = params.row.sColumnList;
                        if (options == null || options.length < 1) {
                            return;
                        }
                        //下拉框内容包裹在一个div里面
                        return createElement(
                            'div',
                            {
                                style: {
                                    height: '56px'
                                }
                            },
                            [
                                createElement('td-select', {
                                    style: {
                                        marginTop: '10px',
                                        width: '120px;'
                                    },
                                    //td-select实现下拉框
                                    on: {
                                        input: value => {
                                            //随着下拉框的不同，文字框里的内容在边
                                            this.selectModule[params.row.sTableName + '_desc'] = value;
                                        }
                                    },
                                    props: {
                                        value: this.selectModule[params.row.sTableName + '_desc'],
                                        options: options
                                    }
                                })
                            ]
                        );
                    }
                }
            ]
        };
    },
    // 定义并实现方法体
    methods: {
        // 查询数据
        btnQuery() {
            this.loading = true;
            if (this.formQuery.sTableName != null && this.formQuery.sTableName != '') {
                this.pageNum = 1;
            }
            this.queryDataList();
        },

        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryDataList();
        },

        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryDataList();
        },

        // 获取查询参数
        getParam: function() {
            let queryVo = {
                needPage: true,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            };
            if (this.treeNode != null && this.treeNode.sId != null && this.treeNode.sId !== '' && this.treeNode.sId !== undefined) {
                queryVo.sDatabaseId = this.treeNode.sId;
            } else {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT_DATABASE'), type: 'warning' });
                return;
            }
            queryVo.sTableName = this.formQuery.sTableName;
            return queryVo;
        },

        // 查询列表信息
        queryDataList() {
            let param = this.getParam();
            dlgTrusteeshipApi.listUnTrusteeshipTables(JSON.stringify(param), response => {
                this.loading = false;
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('setting/tableController/listUnTrusteeshipTables', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
            });
        },

        // 提交数据
        submitForm() {
            this.addLoading = true;
            let items = this.$refs.tableInfo.getSelectAllRows();
            if (items == null || items.length === 0) {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT'), type: 'warning' });
                this.addLoading = false;
                return;
            }
            let content = {};
            let trusteeshipList = [];
            let alertInfo = '';
            for (let i = 0; i < items.length; i++) {
                let iDictionary = this.checkedMap.has(items[i].sTableName) ? '1' : '0';
                let sKeyField = this.selectModule[items[i].sTableName + '_key'];
                if (sKeyField == null || sKeyField === '') {
                    alertInfo += items[i].sTableName + this.$t('pgCommon.KEY_FIELD_NOT_SELECT') + this.$t('pgCommon.PROMPT_SEPARATOR');
                }
                let sValueField = this.selectModule[items[i].sTableName + '_value'];
                if (sValueField == null || sValueField === '') {
                    alertInfo += items[i].sTableName + this.$t('pgCommon.VALUE_FIELD_NOT_SELECT') + this.$t('pgCommon.PROMPT_SEPARATOR');
                }
                let sDescField = this.selectModule[items[i].sTableName + '_desc'];
                let param = {
                    sTableName: items[i].sTableName,
                    sTableNotes: items[i].sTableNotes,
                    iDictionary: iDictionary,
                    sKeyField: sKeyField,
                    sValueField: sValueField,
                    sDescField: sDescField
                };
                trusteeshipList.push(param);
            }
            if (alertInfo != '') {
                this.$message({ showClose: true, message: alertInfo.substring(0, alertInfo.length - 2), type: 'warning', duration: '10000' });
                this.addLoading = false;
                return;
            }
            content.sDatabaseId = this.treeNode.sId;
            content.trusteeshipList = trusteeshipList;
            dlgTrusteeshipApi.insertTrusteeship(JSON.stringify(content), response => {
                this.addLoading = false;
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('dlgTrusteeshipApi.insertTrusteeship', response);
                    return;
                }
                this.$message({ showClose: true, message: this.$t('pgCommon.ADD_SUCCESS'), type: 'success' });
                this.$emit('addOnSuccess', response.data.content);
            });
        },

        // checkbox控件change时间
        checkBoxChange(item, val) {
            if (val === true) {
                this.$refs.tableInfo.toggleRowSelection(item, true);
                this.checkedMap.set(item.sTableName, item);
            } else {
                this.checkedMap.remove(item.sTableName);
            }
        },

        // 取消
        cancel() {
            this.trusteeshipAddDialogClose();
        },

        // 关闭窗口之前需要调用的方法
        trusteeshipAddDialogClose() {
            this.$emit('trusteeshipAddDialogClose');
        }
    }
};
</script>
<style scoped>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
